import styled from 'styled-components'

export default styled.section`
    background: ${({ theme }) => theme.backgroundLight};
    color: ${({ theme }) => theme.colorText};
    a {
        text-decoration: none;
    }
`